import { ArrowRight, ChevronUp, X } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";

const money = (n) => `S$${Number(n).toFixed(2)}`;

export const BookingCartBar = ({ items, subtotal, minAmount, missing, locked, open, setOpen, onContinue, onRemove, onClear }) => {
    if (items.length === 0) return null;
    const short = Math.max(0, minAmount - subtotal);
    const pct = minAmount > 0 ? Math.min(100, (subtotal / minAmount) * 100) : 100;
    const blocked = short > 0 || missing.length > 0;
    const hint = missing.length ? `Pick an option for ${missing.join(", ")}` : short > 0 ? `Add ${money(short)} more (min ${money(minAmount)})` : "Next: choose your date & time";
    return (
        <>
            <div className="fixed bottom-0 inset-x-0 z-30 bg-[#FFFAF6]/95 backdrop-blur-md border-t border-[#C29A5B]/40 shadow-[0_-12px_30px_-18px_rgba(107,21,53,0.45)]" data-testid="booking-cart-bar">
                {short > 0 && <div className="h-1 bg-[#6B1535]/10"><div className="h-full bg-[#6B1535] transition-all duration-500" style={{ width: `${pct}%` }} data-testid="cart-min-progress" /></div>}
                <div className="max-w-3xl mx-auto px-5 sm:px-6 py-3 flex items-center gap-3">
                    <button type="button" onClick={() => setOpen(true)} className="flex-1 min-w-0 text-left" data-testid="cart-bar-open">
                        <span className="flex items-center gap-2 text-[#3D0C1F]">
                            <span className="font-semibold" data-testid="cart-bar-count">{items.length} {items.length === 1 ? "item" : "items"}</span>
                            <span className="text-[#C29A5B]">·</span>
                            <span className="font-semibold" data-testid="cart-bar-total">{money(subtotal)}</span>
                            <ChevronUp size={14} className="text-[#8F622C]" />
                        </span>
                        <span className={`block text-[0.7rem] mt-0.5 truncate ${blocked ? "text-amber-700" : "text-[#7A5262]"}`} data-testid="cart-bar-hint">{hint}</span>
                    </button>
                    <button type="button" onClick={onContinue} disabled={blocked} className="btn-gold !px-5 sm:!px-7 !py-3 shrink-0 disabled:opacity-40 disabled:cursor-not-allowed" data-testid="continue-to-checkout">
                        Continue <ArrowRight size={14} />
                    </button>
                </div>
            </div>
            <Sheet open={open} onOpenChange={setOpen}>
                <SheetContent side="bottom" className="bg-[#FFFAF6] border-t border-[#C29A5B]/40 max-h-[80vh] overflow-y-auto" data-testid="cart-sheet">
                    <div className="max-w-3xl mx-auto w-full">
                    <SheetHeader>
                        <SheetTitle className="font-serif-display text-2xl text-[#3D0C1F] text-left">Your selection</SheetTitle>
                    </SheetHeader>
                    <div className="mt-4 divide-y divide-[#6B1535]/10">
                        {items.map((it) => (
                            <div key={it.key} className="flex items-center gap-3 py-3" data-testid={`cart-item-${it.key}`}>
                                <span className="flex-1 text-sm text-[#3D0C1F]">{it.name}</span>
                                <span className="text-sm text-[#3D0C1F]">{money(it.price)}</span>
                                {!locked && (
                                    <button type="button" onClick={() => onRemove(it)} className="w-8 h-8 rounded-full flex items-center justify-center text-[#7A5262] hover:bg-red-50 hover:text-red-700" aria-label={`Remove ${it.name}`} data-testid={`cart-remove-${it.key}`}>
                                        <X size={15} />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="mt-4 pt-4 border-t border-[#6B1535]/15 flex items-center justify-between">
                        <span className="text-xs tracking-[0.2em] uppercase text-[#7A5262]">Subtotal</span>
                        <span className="font-serif-display text-2xl text-[#3D0C1F]">{money(subtotal)}</span>
                    </div>
                    <p className={`text-[0.75rem] mt-1 ${blocked ? "text-amber-700" : "text-[#8A6574]"}`} data-testid="cart-sheet-hint">{blocked ? hint : "Discounts, rewards and credits are applied at checkout."}</p>
                    <div className="mt-5 flex gap-3">
                        {!locked && <button type="button" onClick={onClear} className="px-4 text-xs tracking-[0.18em] uppercase text-[#7A5262] underline underline-offset-4 hover:text-red-700" data-testid="clear-services">Clear all</button>}
                        <button type="button" onClick={() => { setOpen(false); onContinue(); }} disabled={blocked} className="btn-gold flex-1 justify-center disabled:opacity-40" data-testid="cart-sheet-continue">
                            Continue <ArrowRight size={14} />
                        </button>
                    </div>
                    </div>
                </SheetContent>
            </Sheet>
        </>
    );
};
